export const POPOVER_STORAGE_KEY = {
  en: 'en_popover',
  ru: 'ru_popover'
}
